import React, { useEffect, useState, useRef } from "react";
import Popover from "../project/Popover";
import { getAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import { useSelector, useDispatch } from "react-redux";
import { dateFormat , getRangeDates} from "../../services/Util";
import { updateOrder as reduxUpdateOrder } from "../../redux/reducers/ProjectStatusOrder";
import Constants from "../../Constants";
import { RotatingLines } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";
import $ from "jquery"
import { handleError } from "../../services/authApiRoutes/APImethods";
import { useTranslation } from "react-i18next";


export default function ProjectStatusCountBlock() {
  const colorCode = {
    "All Open Projects": "alert-light-blue",
    "In Creation": "alert-light-green",
    "Waiting For Quote Selection": "alert-light-purple",
    "In Translation": "alert-light-floralw",
    "In Review": "alert-light-sky",
    "Waiting for Vendor Acceptance": "alert-light-cream",
  };
  const { t } = useTranslation();
  const translate = t;
  const navigate= useNavigate();
  const refButton1 = useRef(null);
  const refButton2 = useRef(null);
  const refButton3 = useRef(null);
  const refButton4 = useRef(null);
  const refButton5 = useRef(null);
  const refButton6 = useRef(null);
  const [projectDeliveryStatusCount, updateCount] = useState([]);
  const [dashboardTilesStatus, setDashboardTilesStatus] = useState([]);
  const tilesMenu = useRef(null);
  const [allProjectStatus, updateProjectStatus] = useState([]);
  const [toggle, toggleFilter] = useState(false);
  const followed = useSelector((FollowingSlice) => FollowingSlice.follow).value;
  const [popupIndex, setPopupIndex] = useState(0)
  const order = useSelector(
    (reduxUpdateOrder) => reduxUpdateOrder.order_status
  ).value;
  const dispatch = useDispatch();
  const selectedRange = useSelector((CalendarRangeSlice) => CalendarRangeSlice.calendar_range).range;
  const selectedDateRangeRedux = getRangeDates(selectedRange);

  const SelectDepartMentRedux = useSelector(
    (SelectDropDownSlice) => SelectDropDownSlice.select_dropdown
  ).value;
  const SelectLanguageRedux = useSelector(
    (languageSelected) => languageSelected.selected_language
  ).value;
  
  const startDate = dateFormat(
    selectedDateRangeRedux[0],
    Constants.DATE_FORMAT
  );
  const endDate = dateFormat(selectedDateRangeRedux[1], Constants.DATE_FORMAT);
  
  const startDateInitial = dateFormat(
    selectedDateRangeRedux[0],
    Constants.DATE_FORMAT_MM_DD_YYYY
  );
  const endDateInitial = dateFormat(selectedDateRangeRedux[1], Constants.DATE_FORMAT_MM_DD_YYYY);
  const selectedOption = useSelector((projectCountFilter) => projectCountFilter.project_status_display).value;
  useEffect(() => {
     if(selectedOption[1]?.data !==undefined){
      let currentSelectedData=projectDeliveryStatusCount.find(status=>status.statusKey ===selectedOption[1].data)
     let data=dashboardTilesStatus.map((data,index)=>(index === popupIndex ? currentSelectedData : data))
      setDashboardTilesStatus(data)
     }
  }, [selectedOption]);

  const departmentId =
    SelectDepartMentRedux !== "" 
      ? `&deptId=${SelectDepartMentRedux}`
      : "";

  const languageId = SelectLanguageRedux !== "" 
    ? `&language=${SelectLanguageRedux}`
    : "";    

  const toggleSetting = (event,index) => {
    if (event.code === "Enter") {
      if (event.target.children[1]?.className === "popover-body") {
        $(event.target).attr('aria-expanded', 'true');
        tilesMenu.current = event.target.children[0].children[3].id
        event.target.children[0].children[3].style.display = "block";
        event.target.children[1].style.display = "block";
        $(event.target.children[1]).find('input:first').trigger('focus');
      }
      toggleFilter(true);
    setPopupIndex(index)
    }
    if (event.type === "click" && event.target !=="div.inner-popover") {
      const elem = $(document.activeElement);
      if (event.target.children[1]?.className === "popover-body") {
        elem.attr('aria-expanded', 'true');
        tilesMenu.current = event.target.children[0].children[3].id
        event.target.children[0].children[3].style.display = "block";
        event.target.children[1].style.display = "block";
        $(event.target.children[1]).find('input:first').trigger('focus');
      } else if (elem.length) {
        elem.find('.popover-body').css('display', 'none');
        elem.find('.triangle-with-shadow').css('display', 'none');
      }
      toggleFilter(true);
    setPopupIndex(index)
    }
    setPopupIndex(index)
  };

  let tileStatusStaticData=[
    {
        "shortLabel": "All Open Projects",
        "statusKey": "projectStatusOpen",
        "value": "projectStatusOpen",
        "code": "projectStatusOpen",
        "label": "All Open Projects",
        "count": 0
    },
    {
        "shortLabel": "Waiting For Tm Upload",
        "statusKey": "projectStatusAllTranslationApproved",
        "code": "projectStatusAllTranslationApproved",
        "label": "Waiting For Tm Upload",
        "count": 0
    },
    {
      "shortLabel": "In Translation",
      "statusKey": "projectStatusInTranslation",
      "code": "projectStatusInTranslation",
      "label": "In Translation",
      "count": 0
  },
    {
        "shortLabel": "In Creation",
        "statusKey": "projectStatusInCreation",
        "code": "projectStatusInCreation",
        "label": "In Creation",
        "count": 0
    },
    {
        "shortLabel": "In Quoting",
        "statusKey": "inBidding",
        "value": "inBidding",
        "code": "inBidding",
        "label": "In Quoting",
        "count": 0
    },
    {
        "shortLabel": "In Review",
        "statusKey": "projectStatusInReview",
        "code": "projectStatusInReview",
        "label": "In Review",
        "count": 0
    }
]

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        refButton1?.current?.children[1] &&
        !refButton1?.current?.contains(event.target)
      ) {
        refButton1.current.children[0].children[3].style.display = "none";
        refButton1.current.children[1].style.display = "none";
      }
      if (
        refButton2.current?.children[1] &&
        !refButton2.current?.contains(event.target)
      ) {
        refButton2.current.children[0].children[3].style.display = "none";
        refButton2.current.children[1].style.display = "none";
      }
      if (
        refButton3.current?.children[1] &&
        !refButton3.current?.contains(event.target)
      ) {
        refButton3.current.children[0].children[3].style.display = "none";
        refButton3.current.children[1].style.display = "none";
      }
      if (
        refButton4.current?.children[1] &&
        !refButton4.current?.contains(event.target)
      ) {
        refButton4.current.children[0].children[3].style.display = "none";
        refButton4.current.children[1].style.display = "none";
      }
      if (
        refButton5.current?.children[1] &&
        !refButton5.current?.contains(event.target)
      ) {
        refButton5.current.children[0].children[3].style.display = "none";
        refButton5.current.children[1].style.display = "none";
      }
      if (
        refButton6.current?.children[1] &&
        !refButton6.current?.contains(event.target)
      ) {
        refButton6.current.children[0].children[3].style.display = "none";
        refButton6.current.children[1].style.display = "none";
      }
    };
    const handleEscape = (event) => {
      if (event.key === "Escape" && refButton1.current?.contains(event.target)) {
        refButton1.current.children[0].children[3].style.display = "none";
        refButton1.current.children[1].style.display = "none";
      }
      if (event.key === "Escape" && refButton2.current?.contains(event.target)) {
        refButton2.current.children[0].children[3].style.display = "none";
        refButton2.current.children[1].style.display = "none";
      }
      if (event?.key === "Escape" && refButton3?.current?.contains(event.target)) {
        refButton3.current.children[0].children[3].style.display = "none";
        refButton3.current.children[1].style.display = "none";
      }
      if (event.key === "Escape" && refButton4.current?.contains(event.target)) {
        refButton4.current.children[0].children[3].style.display = "none";
        refButton4.current.children[1].style.display = "none";
      }
      if (event.key === "Escape" && refButton5.current?.contains(event?.target)) {
        refButton5.current.children[0].children[3].style.display = "none";
        refButton5.current.children[1].style.display = "none";
      }
      if (event.key === "Escape" && refButton6.current?.contains(event.target)) {
        refButton6.current.children[0].children[3].style.display = "none";
        refButton6.current.children[1].style.display = "none";
      }
      if (event?.key === Constants.ESCAPE && tilesMenu?.current){
        $('#'+tilesMenu.current).closest('.selection-department').attr('aria-expanded', 'false');
        $('#'+tilesMenu.current).closest('.selection-department').trigger('focus');
        tilesMenu.current = '';
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    document.addEventListener("focus", handleClickOutside, true);
    document.addEventListener("keydown", handleEscape, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
      document.removeEventListener("focus", handleClickOutside, true);
      document.removeEventListener("keydown", handleEscape, true);
    };
  }, [refButton1, refButton2, refButton3, refButton4, refButton5, refButton6]);

  const projStatusFilterSelector = useSelector(
    (projectCountFilter) => projectCountFilter.project_status_display
  ).value;
  const selectedPosition = projStatusFilterSelector[0]?.position;
  const selectedData = projStatusFilterSelector[1]?.data;

  useEffect(() => {
    getAxiosResponse(
      APIUrls.PROJECT_STATUS_COUNT +
        `?onlyFollowed=${followed}&startDate=${startDate}&endDate=${endDate}${departmentId}${languageId}`
    )
      .then((res) => {
        if (res.data.data?.length > 0) {
          updateProjectStatus(res.data.data);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    if (allProjectStatus.length > 0) {
      const orignalPosition = allProjectStatus.findIndex(
        (proStat) => proStat.statusKey === selectedData
      );

      const newOrder = order.map((ord, index) => {
        if (index === selectedPosition) {
          return ord, orignalPosition;
        }
        return ord;
      });
      dispatch(reduxUpdateOrder(newOrder));
    }
    
  }, [
    endDate,
    selectedData,
    selectedPosition,
    startDate,
    followed,
    departmentId,
    languageId
  ]);

  const getPath=(path)=>{
    //allProjectStatus[order[0]]?.path
    let array = path?.split("/");
    const length = array.length;
    let part = "";
    if(length){
      part= array[length-1];
    }
    return part?`&${part}`:"";
  };

  const handlingTile=()=>{
    navigate("/projects",{state:{projectType:getPath(allProjectStatus[order[5]]?.path)}});
  };
  
  const keydownHandlingTile=(event)=>{
    if (event.key === Constants.ENTER){
      handlingTile();
    }
  };

  useEffect(()=>{
    fetchProjectSearchCount()
  },[startDate,endDate,followed])

  const fetchProjectSearchCount = ()=>{
    let count=0;
    let biddingCount=0;
    getAxiosResponse(APIUrls.PROJECT_DELIVERY_STATUS_COUNT +`?onlyFollowed=${followed}&page=1&startDate=${startDateInitial}&endDate=${endDateInitial}`)
    .then((res) => {
      if(res?.data?.code===200){
        if(res?.data?.data && res?.data?.data?.length > 0 ){
       let status=res?.data?.data.filter(data=> data.status !=="")
       if(status && status?.length > 0){
       status.forEach(data=>{
            if(data.status !=="projectStatusCanceled" || data.status !=="projectStatusInCancellation"){
                count=count+data.count 
            }
       })
       status.forEach(data=>{
        if((data.status === "projectStatusSubmittedForBids") 
            || (data.status === "projectStatusWaitingForBidSelection") 
            || (data.status === "projectStatusWaitingForInternalTranslator") 
            || (data.status === "projectStatusRejectedByInternalTranslator") 
            || (data.status === "projectStatusWaitingForVendorAcceptance") 
            || (data.status === "projectStatusRejectedByVendor") 
            ){
              biddingCount += data.count
            }
       })
       let openCountStatus={shortLabel:translate("project_listing.projectStatusOpen"),statusKey:"projectStatusOpen",value:"projectStatusOpen",code:"projectStatusOpen",label:translate("project_listing.projectStatusOpen"),count:count}
       let inBidding={shortLabel:translate("project_listing.in_bidding"),statusKey:"inBidding",value:"inBidding",code:"inBidding",label:translate("project_listing.in_bidding"),count:biddingCount}
       let statusData=[]
       statusData=status.map(data=>{
             if((data.status !== "projectStatusSubmittedForBids") 
             && (data.status !== "projectStatusWaitingForBidSelection") 
             && (data.status !== "projectStatusWaitingForInternalTranslator") 
             && (data.status !== "projectStatusRejectedByInternalTranslator") 
             && (data.status !== "projectStatusWaitingForVendorAcceptance") 
             && (data.status !== "projectStatusRejectedByVendor") 
             ){
              return {shortLabel:translate(`project_listing.${data.status}`), statusKey:data.status ,code:data.status,label:translate(`project_listing.${data.status}`),count:data.count}
             }
       }).filter(data=>data !==undefined)
       statusData.unshift(openCountStatus,inBidding) 
       if(statusData  && statusData.length < 7 ){
        tileStatusStaticData.forEach(data=>{
          if(!statusData.find(status=>status?.shortLabel===data?.shortLabel)){
            statusData.push(data)
          } 
        }) 
       }
       const tileStatus=[]
       if(statusData && statusData.length > 0){
        statusData.forEach((data,index)=>{
          if( data.code !=="projectStatusInError"){
            if(tileStatus.length < 6){
              tileStatus.push(data)
            }
          }
        })
        setDashboardTilesStatus(tileStatus)
       }
        updateCount(statusData.sort((a,b) => a.label.localeCompare(b.label)));
        }
      }
      }
    }).catch((err) => {
        console.error(err);
    });
  };
  return (
    <>
      <ul className="list-box-block flex" data-tour="tile-box">
        {dashboardTilesStatus.map((tiles,index)=>(
        <li aria-label={tiles?.label} >
        <div
          className={
            "list-box " + Object.values(colorCode)[index]
          }
        >
          <div tabIndex="0" className="number-text" role="link" style={tiles?.count !== 0 ? {cursor:"pointer"}:{}}
          onClick={()=>{tiles.count > 0 ? navigate("/projects",{state:{screen:"dashboard",projectType:tiles?.statusKey}}):navigate("/dashboard")}}
          onKeyDown={(e)=>{if (e.key === Constants.ENTER){tiles.count > 0 ? navigate("/projects",{state:{screen:"dashboard",projectType:tiles?.statusKey}}):navigate("/dashboard")}}}
          >
            <strong>{tiles?.count} </strong>
            <p>{tiles?.label ==="Error" && tiles?.count > 1 ?"Errors":tiles?.label}</p>
          </div>
          <div
            className="selection-department hover"
            role="button"
            aria-label="select status menu"
            tabIndex="0"
            aria-expanded="false"
            onClick={(e) => {
              toggleSetting(e,index);
            }}
            onKeyDown={(e) => {
              toggleSetting(e,index);
            }}
            ref={refButton1}
          >
            <div className="dots" data-tour="3-dots">
              <span></span>
              <span></span>
              <span></span>
              {index ===popupIndex &&
              <div 
                id={tiles?.value}
                className="triangle-with-shadow"></div>
              }
            </div>
            {index ===popupIndex &&
            <div className="popover-body" ref={refButton1}>

              <Popover
                key={tiles?.label}
                type={projectDeliveryStatusCount}
                defSelected={tiles?.statusKey}
                uniqueId={5}
                dashboardTilesStatus={dashboardTilesStatus}
                index={popupIndex}
              />
            </div>}
          </div>
        </div>
      </li>
        ))}
      </ul>
    </>
  );
}
